import React, { Component } from "react";
import moment from "moment";
import Bridge from "../../../utils/Bridge";
import { Spin } from "antd";

export default class KeyStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      loading: false,
    };
  }
  componentDidMount() {
    this.get_eals_frs_list();
  }
  get_eals_frs_list = () => {
    this.setState({ loading: true });
    let params = `?eals_id=` + localStorage.getItem("ap_eals_id");
    Bridge.personal_data_viewer.le_study
      .get_le_study_session_list(params)
      .then((res) => {
        if (res.status == "1") {
          
          // Sort by date_created descending
          const sortedData = res.data.sort((a, b) => {
            const dateA = a.date_created ? new Date(a.date_created) : new Date(0);
            const dateB = b.date_created ? new Date(b.date_created) : new Date(0);
            return dateB - dateA; // Descending order (newest first)
          });
          
          this.setState({
            records: sortedData,
          });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  render() {
    const formData = this.props.language;
    return (
      <div className="als_frs_sessions">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 px-0">
              <Spin spinning={this.state.loading}>
                {this.state.records.length > 0 && (
                  <table>
                    <tr>
                      <th>
                        {
                          formData.page.personalDataViewer.keyStatics
                            .sessionDate
                        }
                      </th>
                      <th>
                        {
                          formData.page.personalDataViewer.keyStatics
                            .speakingRate
                        }
                      </th>
                      {/* <th>{formData.page.personalDataViewer.keyStatics.articulatoryRate}</th> */}
                      {/* <th>{formData.page.personalDataViewer.keyStatics.pauseTime}</th> */}
                      <th>
                        {
                          formData.page.personalDataViewer.keyStatics
                            .totalDuration
                        }
                      </th>
                    </tr>
                    {this.state.records &&
                      this.state.records.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              {item.date_created
                                ? moment(item.date_created).format("MM/DD/YYYY")
                                : "---"}
                            </td>
                            <td>
                              {item.speaking_rate !== null &&
                              item.speaking_rate !== undefined
                                ? item.speaking_rate
                                : "---"}
                            </td>
                            {/* <td>---</td> */}
                            {/* <td>---</td> */}
                            <td>{item.total_duration}</td>
                          </tr>
                        );
                      })}
                  </table>
                )}
                {this.state.records.length == 0 && (
                  <div className="col-lg-12">
                    <div
                      style={{
                        fontSize: 20,
                        textAlign: "center",
                        padding: 20,
                      }}
                    >
                      {this.props.language.page.notAvailable}
                    </div>
                  </div>
                )}
              </Spin>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
